import { error, finish } from '../../../modules/liabilities/actions/multiples-line-details';
import api from '../../../api';

export function request(dispatch, { selectionIds }) {
    api.post('/liabilities-alerts/multiples-line-details', {
        selectionIds: selectionIds
    }).then(
        result => dispatch(finish(result.selections)),
        errors => dispatch(error(errors))
    );
}
